/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-03 11:08:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-02 18:38:41
 * @FilePath: /src/store/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createStore } from 'zustand/vanilla';

import { defaultState, StoreState } from './defaultState';
import { CartSlice, createCartSlice } from './slices/cartSlice';
import {
  CaLensFlowExperimentSlice,
  createCaLensFlowExperimentSlice,
} from './slices/caLensFlowExperimentSlice';
import { createGlobalDialogSlice, GlobalDialogSlice } from './slices/globalDialogSlice';
import { createGlobalSlice, GlobalSlice } from './slices/globalSlice';
import { createGoodsDetailSlice, GoodsDetailSlice } from './slices/goodsDetailSlice';
import { createGoodsListSlice, GoodsListSlice } from './slices/goodsListSlice';
import { createOrderSlice, OrderSlice } from './slices/orderSlice';
import { createPageCacheSlice, PageCacheSlice } from './slices/pageCacheSlice';
import { createRouteSlice, RouteSlice } from './slices/routeSlice';
import { createSurveySlice, SurveySlice } from './slices/surveySlice';
import { createTryonSlice, TryonSlice } from './slices/tryonSlice';
import { createUserSlice, UserSlice } from './slices/userSlice';
import { createWishSlice, WishSlice } from './slices/wishSlice';

// 合并所有的 Slice 类型
export type Store = GlobalSlice &
  CaLensFlowExperimentSlice &
  UserSlice &
  SurveySlice &
  CartSlice &
  GoodsDetailSlice &
  GoodsListSlice &
  OrderSlice &
  WishSlice &
  PageCacheSlice &
  TryonSlice &
  GlobalDialogSlice &
  RouteSlice;

// Store instance that can be accessed from anywhere
let storeInstance: ReturnType<typeof createAppStore> | null = null;

export const createAppStore = (initialServerData: Partial<StoreState> = {}) => {
  const store = createStore<Store>()((set, get, storeApi) => ({
    ...createGoodsDetailSlice(set, get, storeApi),
    ...createGoodsListSlice(set, get, storeApi),
    ...createGlobalSlice(set, get, storeApi),
    ...createCaLensFlowExperimentSlice(set, get, storeApi),
    ...createUserSlice(set, get, storeApi),
    ...createSurveySlice(set, get, storeApi),
    ...createCartSlice(set, get, storeApi),
    ...createOrderSlice(set, get, storeApi),
    ...createWishSlice(set, get, storeApi),
    ...createPageCacheSlice(set, get, storeApi),
    ...createTryonSlice(set, get, storeApi),
    ...createGlobalDialogSlice(set, get, storeApi),
    ...createRouteSlice(set, get, storeApi),

    /**
     * @CAUTION 这个必须放在默认状态的最后
     */
    ...initialServerData,
  }));

  // TODO: 在 axios 中获取的实例对象这样无法唤起验证码弹窗
  // if (!storeInstance) {
  //   storeInstance = store;
  // }

  storeInstance = store;

  return store;
};

// Function to access store state outside of React components
export const getStoreState = (): StoreState => {
  if (!storeInstance) {
    // Initialize with default state if not initialized yet
    return defaultState;
  }
  return storeInstance.getState();
};

export const getStoreInstance = (): ReturnType<typeof createAppStore> | null => {
  return storeInstance;
};
